<template>
    <nav class="Tabs">
        <Tab :text="SearchTabText.PROGRAMMES" :selected="selectedTabProgrammes" @click="switchTab(SearchTabText.PROGRAMMES)"/>
        <Tab :text="SearchTabText.UNIVERSITIES" :selected="selectedTabUniversities" @click="switchTab(SearchTabText.UNIVERSITIES)" />
        <Tab v-if="shouldDisplayScholarshipsTab" :text="SearchTabText.SCHOLARSHIPS" :selected="selectedTabScholarships" @click="switchTab(SearchTabText.SCHOLARSHIPS)" />
    </nav>
</template>

<script setup lang="ts">
import { SearchTabText } from '@domain/enums/SearchTabText';
import Tab from './Tab/Tab.vue';
import { computed } from 'vue';
import { useSearchStore } from '@app/stores/useSearchStore';
import { PortalType } from '@studyportals/domain-client';
import { SearchType } from '@domain/enums/SearchType.js';

const store =  useSearchStore();

const selectedTabProgrammes = computed(() => store.searchType === SearchType.PROGRAMME_SEARCH);
const selectedTabUniversities = computed(() => store.searchType === SearchType.UNIVERSITY_SEARCH);
const selectedTabScholarships = computed(() => store.searchType === SearchType.SCHOLARSHIP_SEARCH);

const shouldDisplayScholarshipsTab = computed(() => {
    return store.portalType === PortalType.MASTER
        || store.portalType === PortalType.BACHELOR
        || store.portalType === PortalType.PHD;
});

const switchTab = (tabText: SearchTabText) => store.setSearchTab(tabText);
</script>

<style scoped lang="scss">
.Tabs {
    display: flex;
    @include PaddingAreas(0.5, 0, 0, 0);
    gap: 1rem;
}
</style>
